import type { AudioGroup } from '|>/shared/types/audio'

import { Parser as M3u8Parser } from 'm3u8-parser'
import { atmosCodecsSubstrings } from './lib'

function isAudioGroup(value) {
  return (
    value !== null &&
    typeof value === 'object' &&
    Object.prototype.hasOwnProperty.call(value, 'language')
  )
}

function extractAtmosGroup(groupId: string, value: AudioGroup) {
  const id = groupId.toLowerCase()

  const isAtmos = atmosCodecsSubstrings.some((codec) => id.includes(codec))

  return isAtmos ? value : null
}

export function parseM3u8ForAtmosAudio(masterManifest: string) {
  if (!masterManifest) return []
  const atmosGroups: AudioGroup[] = []

  const parser = new M3u8Parser()
  parser.push(masterManifest)
  parser.end()

  const manifest = parser.manifest

  const audioGroups = manifest.mediaGroups?.AUDIO

  if (audioGroups) {
    Object.entries(audioGroups).forEach(([groupId, possibleGroup]) => {
      Object.entries(possibleGroup as Record<string, AudioGroup>).forEach(
        ([name, value]) => {
          if (isAudioGroup(value)) {
            const atmosGroup = extractAtmosGroup(groupId, { name, ...value })
            if (atmosGroup) atmosGroups.push(atmosGroup)
          }
        }
      )
    })
  }

  return atmosGroups
}
